import React from "react";
import { getString } from "../../utilities";
import { codesOfServerErrors } from "../../config/constants";

export default function ErrorMessage({ error, children = null }) {
  // Check if error message contains one of pre-defined server error codes
  const checkForErrorCodes = (message) => {
    const matchedCode = Object.keys(codesOfServerErrors).find((code) => message.includes(code));

    if (matchedCode) {
      return getString(codesOfServerErrors[matchedCode], { html: true });
    }

    return message;
  };

  const renderMessage = () => {
    if (error.graphQLErrors && error.graphQLErrors.length > 0) {
      if (error.graphQLErrors.length === 1) {
        const errorMessage = checkForErrorCodes(error.graphQLErrors[0].message);
        return <p className="submit-error">{errorMessage}</p>;
      }
      const errorList = error.graphQLErrors.map((e) => {
        const errorMessage = checkForErrorCodes(e.message);
        return <li key={e.message}>{errorMessage}</li>;
      });
      return <ul className="submit-error">{errorList}</ul>;
    }

    return <p className="submit-error">{error.message.replace("[Network]", " ").trim()}</p>;
  };

  return (
    <div className="submit-error-container">
      {renderMessage()}
      {children}
    </div>
  );
}
